module.exports = __webpack_public_path__ + "images/ca8720b124894747f67da217ebc07c66-illu_glassSensorV2.svg";